/**
 * Trạng thái giao dịch từ phía JetPay (postMessage Data.Status / API xem chi tiết status) — khớp backend JetpayStatus
 */
const JetpayStatus = Object.freeze({
  Mkc: 'MKC', // Thu hồi lệnh (Panda: 0 KTV thu hồi, 3 KTT thu hồi)
  Succ: 'SUCC', // Đã chuyển khoản thành công (8)
  Fail: 'FAIL', // Chuyển khoản thất bại (10)
  Wait: 'WAIT', // NH đang xử lý (6)
  JpbhPending: 'JPBH_PENDING', // Chờ phê duyệt thêm — nhiều cấp duyệt nội bộ (1, 4)
  JpbhApproverRejected: 'JPBH_APPROVER_REJECTED', // Người duyệt từ chối (2, 5)
  Bkrj: 'BKRJ', // Ngân hàng từ chối (9)
});

export default {JetpayStatus};
